module.exports = __webpack_public_path__ + "img/guifan1.08c80114.jpg";